import { render } from "./AssessmentQuestions.vue?vue&type=template&id=b0067a40&scoped=true"
import script from "./AssessmentQuestions.vue?vue&type=script&lang=js"
export * from "./AssessmentQuestions.vue?vue&type=script&lang=js"

import "./AssessmentQuestions.vue?vue&type=style&index=0&id=b0067a40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0067a40"]])

export default __exports__